import React from "react";
import BookingProduct from "./BookingProduct";
import DateHelper from "../DateHelper/DateHelper";
import { differenceInDays } from "date-fns";

export default class BookingProducts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cart: this.props.cart || {},
      product_expanded: null,
      currency: {
        id: "USD|$|1",
        name: "United States Dollar",
        iso_code: "USD",
        symbol: "$",
        exchange_rate: 1,
      },
    };

    this.onAddToCart = this.onAddToCart.bind(this);
    this.onRemoveFromCart = this.onRemoveFromCart.bind(this);
    this.onExpandCollapse = this.onExpandCollapse.bind(this);
    this.onChangeReservationSegmentId =
      this.onChangeReservationSegmentId.bind(this);
  }

  componentDidUpdate(prevProps, _prevState) {
    if (
      this.props.reservation_segment_id &&
      this.props.reservation_segment_id !== prevProps.reservation_segment_id
    ) {
      $(window).trigger("bookingProductsReservationSegmentChange");
    }
  }

  /**
   * Render functions
   */

  render() {
    if (this.props.add_on_products?.length > 0) {
      var products = this.props.add_on_products.map((product) => {
        return (
          <BookingProduct
            key={product.id}
            product={product}
            expanded={this.state.product_expanded === product.id}
            onAddToCart={this.onAddToCart}
            onRemoveFromCart={this.onRemoveFromCart}
            onExpandCollapse={this.onExpandCollapse}
            {...this.state}
            {...this.props}
          />
        );
      });
    } else {
      var products = (
        <div className="card" style={{ marginBottom: "15px", padding: "0rem" }}>
          <div
            className="ReservationTotal"
            style={{ padding: "0.5rem", fontWeight: "bold" }}
          >
            {I18n.t("no_add_ons_available")}
          </div>
        </div>
      );
    }

    return (
      <div className="BookingProducts" ref="BookingProducts">
        <div className="row">
          <div
            className={
              this.props.totalComponent || this.props.continueButton
                ? "col-sm-7 booking-products-wrapper"
                : "col-sm-12"
            }
            style={{ position: "static" }}
          >
            <div className="products">
              {this.renderReservationSegmentSelect()}
              {products}
            </div>
          </div>
          {this.props.totalComponent || this.props.continueButton ? (
            <div className="col-sm-5 booking-total-summary-wrapper">
              {this.props.totalComponent}
              {this.props.continueButton}
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  renderReservationSegmentSelect() {
    if (
      this.props.reservation_segments &&
      this.props.reservation_segments.length > 0
    ) {
      var self = this;
      var reservation_segments = this.props.reservation_segments.map(function (
        reservation_segment
      ) {
        var total_guest_count = self.getTotalGuestCount(reservation_segment);
        var duration = differenceInDays(
          DateHelper.parseDateFromBackend(reservation_segment.check_out_date),
          DateHelper.parseDateFromBackend(reservation_segment.check_in_date)
        );

        return (
          <option key={reservation_segment.id} value={reservation_segment.id}>
            {reservation_segment.room_type.name}:&nbsp;
            {DateHelper.printDateToScreen(
              reservation_segment.check_in_date,
              self.props.date_format
            )}{" "}
            -{" "}
            {DateHelper.printDateToScreen(
              reservation_segment.check_out_date,
              self.props.date_format
            )}
            &nbsp; (
            {duration == 1
              ? I18n.t("num_night", { num: duration })
              : I18n.t("num_nights", { num: duration })}
            ,&nbsp;
            {total_guest_count}{" "}
            {total_guest_count == 1
              ? I18n.t("guest").toLowerCase()
              : I18n.t("guests").toLowerCase()}
            )
            {/*<a href="#" className="remove-segment" onClick={self.props.onRemoveReservationSegment.bind(this, reservation_segment.id)}><span className="ss-trash"></span></a>*/}
          </option>
        );
      });

      return (
        <div style={{ marginBottom: "15px" }}>
          {/* <label>{I18n.t('for')}:</label> */}
          <select
            className="form-control"
            value={this.props.reservation_segment_id}
            onChange={this.onChangeReservationSegmentId}
          >
            {reservation_segments}
          </select>
        </div>
      );
    }
  }

  /**
   * Change handlers
   */

  onAddToCart(product_id, quantity) {
    var cart = { ...this.state.cart };

    if (this.props.reservation_segment_id && !cart.hasOwnProperty(this.props.reservation_segment_id)) {
      cart[this.props.reservation_segment_id] = {};
    } else if(!cart.hasOwnProperty('order') && this.props.order){
      cart['order'] = {}
    }

    var product = this.props.add_on_products.find(
      (product) => product.id === product_id
    );

    if (window.dataLayer) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          items: [
            {
              item_name: product.name,
              item_id: product.id,
              price: (product.amount / 100).toFixed(2),
              item_category: "Products",
              item_category2: "Booking Add-On",
              quantity: quantity,
            },
          ],
        },
      });
    }

    cart[this.props.reservation_segment_id ? this.props.reservation_segment_id : this.props.order ? 'order' : null][product_id] = parseInt(quantity);
    this.setState({ cart: cart }, () => {
      if (typeof this.props.onChangeAddOns === "function") {
        this.props.onChangeAddOns(this.state.cart);
      }
    });
  }

  onRemoveFromCart(product_id) {
    var cart = { ...this.state.cart };
    var quantity = cart[this.props.reservation_segment_id][product_id];

    delete cart[this.props.reservation_segment_id][product_id];

    var product = this.props.add_on_products.find(
      (product) => product.id === product_id
    );
    if (window.dataLayer) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
          items: [
            {
              item_name: product.name,
              item_id: product.id,
              price: (product.amount / 100).toFixed(2),
              item_category: "Products",
              item_category2: "Booking Add-On",
              quantity: quantity,
            },
          ],
        },
      });
    }

    this.setState({ cart: cart }, () => {
      if (typeof this.props.onChangeAddOns === "function") {
        this.props.onChangeAddOns(this.state.cart);
      }
    });
  }

  onExpandCollapse(product_id, e) {
    e.stopPropagation();
    e.preventDefault();

    if (product_id === this.state.product_expanded) {
      this.setState({ product_expanded: null });
    } else {
      this.setState({ product_expanded: product_id });
    }
  }

  onChangeReservationSegmentId(e) {
    var reservation_segment_id = e.target.value;
    if (typeof this.props.onChangeReservationSegmentId === "function") {
      $(window).trigger("bookingProductsReservationSegmentChange");
      this.props.onChangeReservationSegmentId(reservation_segment_id);
    }
  }

  /**
   * Helper functions
   */

  getTotalGuestCount(reservation_segment) {
    var count = 0;

    for (
      var i = 0,
        ilen = reservation_segment.reservation_segment_guest_types.length;
      i < ilen;
      i++
    ) {
      count =
        count +
        reservation_segment.reservation_segment_guest_types[i].number_of_guests;
    }

    return count;
  }
}
